module.exports = __webpack_public_path__ + "static/media/social_media_instagram.99bbde52.svg";